<div fxLayout="column" style="padding: 3px;">
    <mat-form-field>
      <mat-select siteUsageTracker [logCategory]="'GlobalTankSearch'"
        [logName]="'GlobalTankSearchSelector'" [(value)]="filterType">
        <mat-option [value]="0">{{ "Header.SerialNumber" | translate }}</mat-option>
        <mat-option [value]="1">{{ "Header.MinNumber" | translate }}</mat-option>
        <mat-option [value]="2">{{ "Header.TankName" | translate }}</mat-option>
        <mat-option [value]="3">{{ "Header.Location" | translate }}</mat-option>
      </mat-select>
    </mat-form-field>
  <div role="presentation" ref="eFilterTextField" class="ag-filter-toolpanel-search-input ag-labeled ag-label-align-left ag-text-field ag-input-field">
              <div ref="eWrapper" class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper" role="presentation">
                  <input class="ag-input-field-input ag-text-field-input" type="text" aria-label="Search" placeholder="Search..." [(ngModel)]="filter">
              </div>
          </div>
  <div fxLayout="row" style="margin-top: 10px;justify-content: flex-end;">
    <div class="button-wrapper">
      <button mat-flat-button color="primary" class="small-button" (click)="applyFilterClicked()" [disabled]="disableApply()">Apply</button>
      <button mat-flat-button color="secondary" class="small-button" (click)="clearFilter()" [disabled]="disableClear()">Clear</button>
    <div>
  </div>
  </div>
